import module from '../shared.module';

module.factory('LoginService', [
  '$timeout',
  function ($timeout) {
    var nextPathSaved;

    return {
      showLogin: function (nextPath) {
        $timeout(function () {
          nextPathSaved = nextPath;
          $('.login-trigger').trigger('click');
        }, 0);
      },
      getNextPath: function () {
        var nextPath = nextPathSaved;
        nextPathSaved = null;
        return nextPath;
      },
    };
  },
]);
